import objectPath from 'object-path'
import { getCurrentUi } from 'designer/component/action/Data'
import { getCompareValue } from 'designer/component/action/condition/State'

const getRuleCopyStatus = (status = {}) => {
  let { isDynamic, isMainDynamic, dynamicName, dynamicKey, dynamicIndex } =
    status

  return {
    isDynamic,
    isMainDynamic,
    dynamicName,
    dynamicKey,
    dynamicIndex,
  }
}

export const onRuleCopy = (
  designContext = {},
  action = {},
  status = {},
) => {
  let {
    setFieldFormData,
    jsonForm = {},
    isUiChanged = {},
    setIsUiChanged,
    urlParams = {},
    setFormData,
  } = designContext
  let formData = status.formData || jsonForm.formData || {}
  let datasources = objectPath.get(designContext, '@datasource') || {}
  let data = {
    formData,
    urlParams,
    datasources,
  }
  let {
    isDynamic,
    isMainDynamic,
    dynamicName,
    dynamicKey,
    dynamicIndex,
  } = getRuleCopyStatus(status)
  let copyFromKey = action?.copyFrom?.key
  let copyFromName = action?.copyFrom?.valueKey
  let copyToKey = action?.copyTo?.key
  let copyFromLayout = action?.copyFrom?.layout
  let copyToUiName
  let copyValue

  if (!copyFromKey || !copyToKey) return undefined

  let copyToUi = getCurrentUi(copyToKey, jsonForm.schema, jsonForm.uischema)
  copyToUiName = copyToUi?.name || copyToKey

  if (isMainDynamic) {
    copyValue = objectPath.get(
      formData,
      `${dynamicName}.${dynamicIndex}.${copyFromName}`,
    )
    if (setFieldFormData) {
      setFieldFormData(
        `${dynamicKey}.${dynamicIndex}.${copyToUiName}`,
        copyValue,
      )
      setFieldFormData(
        `${dynamicName}.${dynamicIndex}.${copyToKey}`,
        copyValue,
      )
    }
  } else if (isDynamic) {
    copyValue = objectPath.get(formData, copyFromName)
    if (setFieldFormData) {
      setFieldFormData(
        `${dynamicKey}.${dynamicIndex}.${copyToUiName}`,
        copyValue,
      )
      setFieldFormData(
        `${dynamicName}.${dynamicIndex}.${copyToKey}`,
        copyValue,
      )
    }
  } else {
    copyValue = getCompareValue(
      copyFromKey,
      copyFromName,
      copyFromLayout,
      data,
    )
    objectPath.set(formData, copyToKey, copyValue)
    objectPath.set(formData, copyToUiName, copyValue)
    if (setFormData) setFormData(formData)
    objectPath.set(isUiChanged, copyToKey, { isRender: true })
    if (setIsUiChanged) setIsUiChanged(isUiChanged)
  }

  return {
    key: copyToKey,
    value: copyValue,
  }
}
